module.exports = __webpack_public_path__ + "assets/img/aboutus_img__colorsystem_2.bd2ac9a3.svg";